import {useState} from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Button,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Popover,
  Toolbar,
  Tooltip,
} from '@material-ui/core';
import {
  Add as AddIcon,
  ArrowDropDown as ArrowDropDownIcon,
  Create as CreateIcon,
  ViewColumn as ViewColumnIcon,
} from '@material-ui/icons';
import green from '@material-ui/core/colors/green';
import {useStyles} from 'Utility/styles';

export default function ProcessOutcomeLobbyActionToolbar(props) {
  const classes = useStyles();
  const {
    selectedProcessOutcome: {id: selectedProcessOutcomeId, outcomeSbsId},
    sbs: {id: sbsId},
  } = props;
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const handleTouchTapPopover = () => setPopoverOpen(true);
  const handleClosePopover = () => setPopoverOpen(false);

  return (
    <Toolbar
      className={classes.toolbar}
      style={{backgroundColor: green['500']}}
    >
      <Typography className={classes.spacer} variant="h6">
        Process Outcome
      </Typography>

      <div className={classes.toolbarDiv}>
        <Tooltip
          title={
            selectedProcessOutcomeId
              ? 'Process Outcome Actions'
              : 'No Process Outcome Selected'
          }
        >
          <span>
            <Button
              variant="outlined"
              color="secondary"
              buttonRef={(node) => setAnchorEl(node)}
              onClick={handleTouchTapPopover}
              style={{marginLeft: 8}}
              disabled={!selectedProcessOutcomeId}
              endIcon={<ArrowDropDownIcon />}
            >
              Process Outcome Actions
            </Button>
          </span>
        </Tooltip>
        <Popover
          open={popoverOpen}
          anchorEl={anchorEl}
          anchorReference="anchorEl"
          anchorOrigin={{
            horizontal: 'right',
            vertical: 'bottom',
          }}
          transformOrigin={{
            horizontal: 'right',
            vertical: 'top',
          }}
          onClose={handleClosePopover}
        >
          <MenuList component="nav">
            <MenuItem
              component="a"
              href={`#/Sbss/${sbsId}/ProcessOutcomes/${selectedProcessOutcomeId}/update`}
            >
              <ListItemIcon>
                <CreateIcon />
              </ListItemIcon>
              <ListItemText primary="edit: process outcome" />
            </MenuItem>
          </MenuList>
        </Popover>
        <Tooltip
          title={outcomeSbsId ? 'View Outcome SBS' : 'No Outcome Selected'}
        >
          <span>
            <Button
              variant="contained"
              color="secondary"
              href={`#/Sbss/${outcomeSbsId}`}
              style={{marginLeft: 8}}
              disabled={!outcomeSbsId}
              startIcon={<ViewColumnIcon />}
            >
              View
            </Button>
          </span>
        </Tooltip>
        <Tooltip title="Add Process Outcome">
          <Button
            variant="contained"
            color="primary"
            href={`#/Sbss/${sbsId}/ProcessOutcomes/create`}
            style={{marginLeft: 8}}
            startIcon={<AddIcon />}
          >
            Process Outcome
          </Button>
        </Tooltip>
      </div>
    </Toolbar>
  );
}

ProcessOutcomeLobbyActionToolbar.propTypes = {
  sbs: PropTypes.object.isRequired,
  selectedProcessOutcome: PropTypes.object.isRequired,
};
